module.exports = __webpack_public_path__ + "img/bim (9).601ed746.png";